import { render, staticRenderFns } from "./ReportStatus.vue?vue&type=template&id=4d0bc73c&scoped=true"
import script from "./ReportStatus.vue?vue&type=script&lang=js"
export * from "./ReportStatus.vue?vue&type=script&lang=js"
import style0 from "./ReportStatus.vue?vue&type=style&index=0&id=4d0bc73c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0bc73c",
  null
  
)

export default component.exports